import React, { Component } from "react";
import { Div, H1, Button, Img, P, Ul, Li } from "glamorous";
import Hammer from "hammerjs";
import Customise from "./Customise";
import data from "../../../data";
import { textActions } from "../../../actions/text";

import styles from "../../../styles";
import icons from "../../../imgs/icons";
import { labelDimensions } from "../../../misc/constants";
import ScrollFixedContainer from "../../common/ScrollFixedContainer";
import { track } from '../../../misc/utils';

import LabelInput from './LabelInput';

class EditorText extends Component {
  constructor() {
    super();

    this.buttons = [
      {
        title: data.copy("textFontBtn"),
        role: "Font",
        icon: icons.font,
        iconWhite: icons.fontWhite
      },
      {
        title: data.copy("textColourBtn"),
        role: "Colour",
        icon: icons.colour,
        iconWhite: icons.colourWhite
      }
    ];
  }

  state = {
    typing: true,
    custom: "",
  };

  componentDidMount() {
    this.ratioUpdate();
    window.addEventListener("resize", this.ratioUpdate.bind(this));
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.ratioUpdate.bind(this));
  }

  ratioUpdate() {
    if (!this.img) {
      // until render
      return;
    }

    this.setState({
      ratio: this.img.clientWidth / 563
    });
  }

  resetText() {
    track.event('button', 'click', 'text_reset');
    this.props.resetText();
    this.props.setArea('EditorSimple');
  }

  render() {
    const activeText = this.getActiveText();
    const { label } = this.props;
    const { ratio } = this.state;

    return (
      <Div className="container">
        <H1 css={styles.editor.title}>{data.copy("textHeadline")}</H1>
        <Div css={styles.editor.columnWrapper}>
          <ScrollFixedContainer>
            <Div>
              <Div css={styles.editor.editCtas}>
                <Div float="right">
                  <Button
                    onClick={this.props.handleTextUndo}
                    css={styles.editor.undoButton}
                  />
                  <Button
                    onClick={() => {
                      this.props.deleteText();
                      this.props.setArea('EditorSimple');
                    }}
                    css={styles.editor.remove}
                  />
                </Div>
              </Div>

              <Div css={styles.editor.previewWrapper}>
                <div
                  ref="preview"
                  style={{ ...styles.text.preview, overflow: "visible" }}
                >
                  {this.state.typing &&
                    <LabelInput
                      updateTextValue={this.props.updateText}
                      message={activeText}
                      onComplete={() => {this.finishEditing()}}
                      ratio={ratio}
                    />}

                  <Div
                    overflow="hidden"
                    position="absolute"
                    top="0"
                    left="0"
                    height="100%"
                    width="100%"
                  >
                    {label.text.map((text, index) => {
                      if (text.skip) {
                        return null;
                      }

                      if (text === activeText && this.state.typing) {
                        // Don't show the currently edited text as textarea won't render on two lines
                        // and it looks odd if you're editing multi-line text
                        return null;
                      }

                      return (
                        <span
                          ref={el => {
                            if (el && !el.eventAttached) {
                              this.addHammerEvents(el, text);
                              el.eventAttached = true;
                            }
                          }}
                          key={`text_${index}`}
                          style={{
                            ...styles.text.textValue,
                            fontFamily: text.fontFamily,
                            fontSize: `${text.fontSize * ratio}px`,
                            color: text.colour,
                            minHeight: 0,
                            transform: `translate(-50% , -50%) translate(${text.x*ratio}px, ${text.y*ratio}px)`,
                            zIndex: 999,
                            boxShadow:
                              this.props.text.selected === index && !this.state.typing && "0 0 0 1px #D5C17D",
                            padding:
                              this.props.text.selected === index && !this.state.typing && "10px"
                          }}
                        >
                          {text.value}
                        </span>
                      );
                    })}
                  </Div>
                  <Img
                    innerRef={el => this.img = el}
                    css={styles.editor.previewImage}
                    src={label.background}
                    onDragStart={evt => evt.preventDefault()}
                  />
                  <Img
                    css={styles.editor.cutLineLeft}
                    src={icons.cutLine}
                    onDragStart={evt => evt.preventDefault()}
                  />
                  <Img
                    css={styles.editor.cutLineRight}
                    src={icons.cutLine}
                    onDragStart={evt => evt.preventDefault()}
                  />
                </div>
              </Div>
            </Div>
          </ScrollFixedContainer>
          <Div css={styles.text.rightCol}>
            <Div css={styles.editor.boxShadow}>
              {this.state.custom && activeText ? (
                <Customise
                  options={this.buttons}
                  setCustom={option => this.setCustom(option)}
                  setColour={this.props.setTextColour}
                  setFontFamily={this.props.setTextFamily}
                  setFontSize={fontSize =>
                    this.props.setTextSize(
                      fontSize,
                      this.props.text.selected,
                      this.props.pushTextSizeAction
                    )
                  }
                  fontSize={activeText.fontSize}
                  fontFamily={activeText.fontFamily}
                  activeColour={activeText.colour}
                  selected={this.state.custom}
                  done={() => {
                    track.event('button', 'click', 'accept_text');
                    this.props.setArea("EditorSimple");
                  }}
                  reset={this.resetText.bind(this)}
                />
              ) : (
                <Div>
                  <Ul css={styles.editMain.buttons} listStyleType="none" padding="0">
                    {this.buttons.map((button, index) => (
                      <Li
                        onClick={() => this.setCustom(button.role)}
                        css={styles.editMain.buttonInverted}
                        key={`button_${index}`}
                      >                        
                        <Div css={styles.editMain.buttonTop}>
                          <Img css={styles.editMain.buttonIcon} src={button.icon} />
                        </Div>
                        <Div css={styles.editMain.buttonText}>
                          <P css={styles.editMain.buttonTitleInverted}>{button.title}</P>
                        </Div>
                      </Li>
                    ))}
                  </Ul>

                  <Button
                    marginTop="15px"
                    css={styles.ctas.initial}
                    onClick={() => {
                      track.event('button', 'click', 'text_accept');
                      this.props.setArea("EditorSimple");
                    }}
                  >
                    {data.copy("doneBtn")}
                  </Button>
                  <Button
                    marginTop="10px"
                    css={styles.ctas.outline}
                    onClick={this.resetText.bind(this)}
                  >
                    {data.copy("textResetBtn")}
                  </Button>
                </Div>
              )}
            </Div>
          </Div>
        </Div>

        <canvas
          ref="paintCanvas"
          width={labelDimensions.width}
          height={labelDimensions.height}
          style={{
            display: "none"
          }}
        />
      </Div>
    );
  }

  updateTextValue(text) {
    // todo remove this fuction
    this.props.updateText(text, this.props.text.selected);
  }

  finishEditing() {
    this.setState({typing: false});
  }

  addHammerEvents(el, text) {
    const hammertime = new Hammer(el);
    const index = this.props.label.text.indexOf(text);

    hammertime.on("tap", evt => {
      if (this.props.text.selected === index) {
        this.setState({ typing: !this.state.typing });
      }
      else {
        this.setState({ typing: false });
        this.props.setSelectedText(evt, index);
      }
    });
    hammertime.on("panstart", () => {
      textActions.onPanStart(index);
    });
    hammertime.on("panmove", evt => {
      this.props.handleTextPanMove({ ...evt });
    });
    hammertime.on("panend", () => {
      this.props.handleTextPanEnd();
    });
  }

  setCustom(option) {
    this.setState({ custom: option });
  }

  getActiveText() {
    return this.props.label.text[this.props.text.selected];
  }
}

export default EditorText;



// WEBPACK FOOTER //
// ./src/components/areas/EditorText/index.js